import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-workout-about',
  templateUrl: './cyclops-workout-about.component.html',
  styleUrls: ['./cyclops-workout-about.component.scss']
})
export class cyclopsWorkoutAboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
